import { createContext } from 'react';

import type { IconName } from '../../element/Icon/icon.types';

import type { AccordionRotation } from './accordions.types';
import { AccordionIconPosition } from './accordions.types';

export type AccordionContextType = {
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
};

export const AccordionsContext = createContext<AccordionContextType>({
  isExpanded: false,
  setIsExpanded: () => {},
});

/*
  What the group decides for every item under it: whether a reveal is eased, and which glyph marks a
  section. Separate from the item context above, which is rebuilt whenever one section opens or
  shuts - these two facts hold still for the whole run.
*/
export type AccordionsGroupContextType = {
  animated?: AccordionRotation;
  icon: IconName;
  iconPosition: AccordionIconPosition;
};

export const AccordionsGroupContext = createContext<AccordionsGroupContextType>(
  { icon: 'arrow-right', iconPosition: AccordionIconPosition.END }
);
